import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=6a603a98&"
import script from "./paging.vue?vue&type=script&lang=js&"
export * from "./paging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Umbraco\\Upgrade\\CareFirst\\v16\\Website\\CarersFirst.Shared.FrontEnd\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a603a98')) {
      api.createRecord('6a603a98', component.options)
    } else {
      api.reload('6a603a98', component.options)
    }
    module.hot.accept("./paging.vue?vue&type=template&id=6a603a98&", function () {
      api.rerender('6a603a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/vue-components/common/listing/paging.vue"
export default component.exports